module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<!--<div class=\"col-sm-8\">-->\r\n    ")
    ; 
    var constants = require('Constants.js').default;
    
    ; __append("\r\n    \r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">\r\n            <h2>Settings Help</h2>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_GETTING_STARTED ))
    ; __append("\"\r\n               target=\"_blank\">Getting Started</a>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_SETTINGS ))
    ; __append("\"\r\n               target=\"_blank\">Settings Help</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_SETTINGS ))
    ; __append("\"\r\n               target=\"_blank\">Settings Help</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-10\">&nbsp;&nbsp;\r\n            <a href=\"")
    ; __append(escapeFn(constants.HELP_SETTINGS ))
    ; __append("\"\r\n               target=\"_blank\">Settings Help</a>\r\n        </div>\r\n    </div>\r\n<!--</div>-->")
  }
  return __output;

}